<template>
  <router-view name="main"></router-view>
</template>

<script>
export default {
  data: () => ({}),
  computed: {},
  props: {
    source: String
  },
  mounted() {
  },
  methods: {}
};
</script>
